import React from 'react';

export type PanicMode = "none" | "direct" | "escalated";

interface EscortCardStateLabelProps {
  state?: string
  timerExpired?: boolean
  isPanic?: boolean
  type?: string
  isResolved?: boolean
  isViolated?: boolean
  panicMode?: PanicMode
}

const EscortCardStateLabel: React.FC<EscortCardStateLabelProps> = ({
  type,
  timerExpired,
  isPanic,
  isResolved,
  isViolated,
  panicMode
}) => {
  // 🔑 Canonical panic detection (supports old + new incidents)
  const isPanicIncident =
    panicMode !== undefined ? panicMode !== "none" : isPanic === true;

  // 🎨 Background color
  let backgroundColor: string;

  if (isPanicIncident) {
    backgroundColor = "rgba(255, 0, 0)"; // Panic
  } else if (isResolved && !isViolated) {
    backgroundColor = "rgba(0, 186, 50)"; // Safe
  } else {
    backgroundColor = "rgba(0, 93, 130)"; // Virtual
  }

  // 🏷️ Label text
  let labelText = "Virtual Escort";

  if (isPanicIncident) {
    labelText = "PANIC";
  } else if (type === "passiveEscort" && timerExpired) {
    labelText = "TIMER EXPIRED";
  }

  return (
    <span
      style={{
        color: "white",
        background: backgroundColor,
        textAlign: "center",
        fontWeight: "bold",
        margin: "14px",
        padding: "5px"
      }}
    >
      {labelText}
    </span>
  );
};


export {
 EscortCardStateLabel
}